import { render, staticRenderFns } from "./ChroniclesRow.vue?vue&type=template&id=0756308c&scoped=true"
import script from "./ChroniclesRow.vue?vue&type=script&lang=js"
export * from "./ChroniclesRow.vue?vue&type=script&lang=js"
import style0 from "./ChroniclesRow.vue?vue&type=style&index=0&id=0756308c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0756308c",
  null
  
)

export default component.exports